import * as React from 'react';
import {RouteComponentProps, withRouter} from "react-router";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Routes from "../../../navigation/route/Route";

class CreateJobButton extends React.Component<RouteComponentProps<{}>, {}> {
	render() {
		return (
			<ButtonPrimary variant={"burgundy"}
						   label={"Create job"}
						   onClick={() => this.props.history.push(Routes.CreateJob)}/>
		);
	}
}

export default withRouter<{}>(CreateJobButton);